/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MyLabelPanel.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/13 @ 1136
 * ---
 * Description:
 */

import {MyLabelLoginForm} from '../../../forms/MyLabelLoginForm';
import {useCallback, useEffect, useState} from 'react';
import {mleDomainGqlClient} from '../../../../api/domain';
import {CREATE_DATAORIGIN} from '../../../../api/domain/mutations.gql';
import {DataOriginType, OriginContentType} from '@revodigital/mle-dataresolver/lib/entities';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../store';
import {NonIdealState, Switch} from '@blueprintjs/core';
import {CompanyHasConnectedCallout} from '../../../common/callout/CompanyHasConnectedCallout';

interface Props {
    onAccessDone?: () => void;
    setCanNext: (value: boolean) => void;
    wasConnected: boolean;
    /**
     * Callback chiamato quando si abilita/disabilita l'accesso a MyLabel
     * @param value
     */
    onConnectChange?: (value: boolean) => void;
}

export const MyLabelPanel = (props: Props) => {
    const [connectMyLabel, setConnectMyLabel] = useState(true);
    const [accessDone, setAccessDone] = useState(false);
    const authData = useSelector((state: RootState) => state.authState);

    const handleMyLabelConnect = useCallback(async () => {
        setAccessDone(true);
        if (authData) {
            // Create data origin only if there isn't
            if (!props.wasConnected) {
                await mleDomainGqlClient.mutate({
                    mutation: CREATE_DATAORIGIN,
                    variables: {
                        input: {
                            type: DataOriginType.REMOTE,
                            hasCredentials: true,
                            resource: '',
                            name: `MyLabel`,
                            contentType: OriginContentType.MyLabel,
                            companyId: authData.user?.company?.id
                        }
                    }
                });
            }
        }

        if (props.onAccessDone)
            props.onAccessDone();
        props.setCanNext(true);
    }, [setAccessDone]);

    useEffect(() => {
        props.setCanNext(false);
    }, [props.setCanNext]);

    return (
        <div className="p-4">
            <Switch innerLabelChecked="Si" innerLabel="No" label="Collega MyLabel"
                    checked={connectMyLabel}
                    onChange={event => {
                        const value = (event.target as HTMLInputElement).checked;
                        setConnectMyLabel(value);

                        if (props.onConnectChange)
                            props.onConnectChange(value);
                        if (!value) props.setCanNext(true);
                        else props.setCanNext(false);
                    }}/>
            {
                props.wasConnected && <CompanyHasConnectedCallout/>
            }
            {
                connectMyLabel ? <div>
                    <div className="text-xl">Accedi a mylabel</div>
                    <div className="bp4-text-muted mb-2">Per utilizzare le funzionalità di
                        MyLabel
                        devi accedere
                    </div>
                    {!accessDone ?
                        <div><MyLabelLoginForm onLoginSuccessful={handleMyLabelConnect}
                                               onLoginError={() => {
                                               }}/>
                        </div> :
                        <NonIdealState title="MyLabel collegato" icon="tick"
                                       description="MyLabel è stato collegato con successo"/>}
                </div> : <NonIdealState title="MyLabel non collegato" icon="control"
                                        description="MyLabel non verrà collegato a questa etichetta. "/>
            }
        </div>
    );
};